/* ----------------- React Native Paper --------------- */
import { Card, Checkbox, List, Text } from "react-native-paper";

/* ----------------- Types --------------- */
import type { CheckboxStateMap, ListItemData, Section } from "./types";

/* ----------------- Helpers --------------- */
import { formatCount } from "@memorang/helpers";

/* ----------------- Hooks --------------- */
import { useAppTheme } from "../../../useAppTheme";

import { Platform } from "react-native";
/* ----------------- Components --------------- */
import CustomChip from "../../CustomChip";
import { CustomListSubheader } from "../../CustomListSubheader";
import TooltipWrapper from "../../TooltipWrapper";

type Props = {
	sections: Section[];
	isReview?: boolean;
	checkboxStateMap?: CheckboxStateMap;
	handleCheckboxStateMapChange: (type: keyof CheckboxStateMap) => void;
	showReview?: boolean;
};
const isWeb = Platform.OS === "web";

const CardContent = ({
	sections,
	isReview,
	checkboxStateMap,
	handleCheckboxStateMapChange,
	showReview,
}: Props) => {
	const theme = useAppTheme();
	const RenderItems = ({ items }: { items: ListItemData[] }) => {
		return (
			<Card.Content
				style={{ paddingLeft: 0, paddingRight: 0, marginRight: -8 }}
			>
				{items.map(
					(
						{ title, description, color, icon, count, type, tooltip },
						index,
					) => {
						const handlePressListItem = () => {
							handleCheckboxStateMapChange(type!);
						};
						return (
							<List.Item
								onPress={showReview ? handlePressListItem : undefined}
								key={index.toString()}
								disabled={count === 0}
								style={{
									cursor: showReview ? "pointer" : "auto",
								}}
								left={(p) =>
									isReview ? (
										<List.Icon
											{...p}
											icon={() => (
												<Checkbox.Android
													disabled={count === 0}
													status={
														checkboxStateMap?.[type!] ? "checked" : "unchecked"
													}
													onPress={handlePressListItem}
													aria-hidden={true}
												/>
											)}
										/>
									) : (
										<List.Icon {...p} color={color} icon={icon} />
									)
								}
								title={<Text variant="bodyMedium">{title}</Text>}
								description={
									description ? (
										<Text variant="bodySmall">{description}</Text>
									) : null
								}
								right={(p) => (
									<List.Icon
										{...p}
										icon={() => {
											return tooltip && isWeb ? (
												<TooltipWrapper title={tooltip}>
													<CustomChip
														style={{
															backgroundColor: color,
														}}
														textStyle={
															{
																color: theme.colors.white,
																cursor: "help",
																// biome-ignore lint/suspicious/noExplicitAny: cursor property needs any bypass
															} as any
														}
													>{`${count} ${formatCount("item", count)}`}</CustomChip>
												</TooltipWrapper>
											) : (
												<CustomChip
													style={{
														backgroundColor: color,
													}}
													textStyle={{
														color: theme.colors.white,
													}}
												>{`${count} ${formatCount("item", count)}`}</CustomChip>
											);
										}}
									/>
								)}
							/>
						);
					},
				)}
			</Card.Content>
		);
	};
	return (
		<>
			{sections.map(({ sectionTitle, items }, index) => {
				return (
					<List.Section key={index.toString()}>
						{sectionTitle ? (
							<CustomListSubheader
								style={{
									paddingLeft: 16,
								}}
							>
								{sectionTitle}
							</CustomListSubheader>
						) : null}
						<RenderItems items={items} />
					</List.Section>
				);
			})}
		</>
	);
};

export default CardContent;
